module.exports = __webpack_public_path__ + "img/battery_new.bb3bf588.jpg";